export default __webpack_public_path__ + "static/media/zalo.4635dfc6.png";